import React from 'react';

import { SVGComponentProps } from './svg.types';
//Icon specifically for Forms, hence- fill and size not updated

const HeartOutlineSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="36"
        height="32"
        viewBox="0 0 36 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.247 4.44568L17.6133 4.97892L17.9797 4.44568C19.6397 2.02924 22.4226 0.444444 25.5724 0.444444C30.6549 0.444444 34.7822 4.57158 34.7822 9.65394C34.7822 12.485 33.7221 15.2708 32.0975 17.8746C30.4737 20.4772 28.3013 22.873 26.1165 24.9151C23.9332 26.9557 21.7479 28.6334 20.1077 29.8012C19.2879 30.3848 18.6053 30.8404 18.1284 31.1495C17.9123 31.2897 17.7384 31.3997 17.6133 31.4779C17.4882 31.3997 17.3144 31.2897 17.0983 31.1495C16.6214 30.8404 15.9388 30.3848 15.119 29.8012C13.4787 28.6334 11.2935 26.9557 9.11015 24.9151C6.92532 22.873 4.75296 20.4772 3.12915 17.8746C1.50456 15.2708 0.444444 12.485 0.444444 9.65394C0.444444 4.57158 4.57172 0.444444 9.65431 0.444444C12.8041 0.444444 15.587 2.02924 17.247 4.44568Z"
          fill="white"
          stroke="#878A92"
          strokeWidth="0.888889"
        />
      </svg>
    </span>
  );
};

export default HeartOutlineSVG;
